<template>
  <section class="relative">
    <ProductAnchorTitle
      :title="$t('Complete your set')"
      class="mb-4"
    />
    <ProductSlider
      ref="complementaryProductsNode"
      :slider-items="complementaryProducts"
      :size="PRODUCT_CARD_SIZE.MEDIUM"
    >
      <template #default="{ currentItem }">
        <PdpComplementaryProductCard
          :product="currentItem"
          @click="onClick(currentItem)"
        />
      </template>
    </ProductSlider>
  </section>
</template>

<script lang="ts">

import { useIntersectionObserver } from '@vueuse/core';

import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';
import { PRODUCT_CARD_SIZE } from '~~/constants/productCardSize';

export default defineComponent({
  name: 'ComplementaryProducts',

  props: {
    complementaryProducts: {
      type: Array as PropType<ProductVariantExtended[]>,
      required: true,
    },
  },
  setup(props) {

    const { trackViewComplementary, trackClickComplementary } = useGtmEvents();
    const complementaryProductsNode = ref<HTMLElement>(null);

    const { onIntersectOnce: onIntersectComplementaryOnce } = useIntersectionObserverEvent({
      onIntersectCallback: () => {

        if (props.complementaryProducts.length) {

          const skus = props.complementaryProducts.map((product: ProductVariantExtended) => product.sku);
          trackViewComplementary(skus);
        
        }
      
      },
    });

    useIntersectionObserver(complementaryProductsNode, onIntersectComplementaryOnce);

    const onClick = (product: ProductVariantExtended) => {

      trackClickComplementary(product.sku);
    
    };

    return {
      PRODUCT_CARD_SIZE,
      complementaryProductsNode,
      onClick,
    };
  
  },
});

</script>
